// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 0,
  pageSize: 20,
  customFilters: [],
  value: "",
  sorting: [],
  sortField: "nom",
  sortOrder: "asc",
  activeTab: "details",
  //Nouveau
  query: "",
  actif: {},
  selectedOptionFilters: null,
  selectedOptionId: null,
  column: [],
};

const FiltrePmes = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_PME:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_PME:
      return {
        ...state,
        currentPage: action.payload,
      };
    case actionTypes.SET_CUSTOM_FILTERS_PME:
      return {
        ...state,
        customFilters: action.payload,
      };
    case actionTypes.SET_SORT_FIELD_PME:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_PAGE_SIZE_PME:
      return {
        ...state,
        pageSize: action.payload,
      };
    case actionTypes.SET_SORTING_PME:
      return {
        ...state,
        sorting: action.payload,
      };
    case actionTypes.SET_ORDER_PME:
      return {
        ...state,
        sortOrder: action.payload,
      };
    case actionTypes.SET_ACTIVE_TAB_PME:
      return {
        ...state,
        activeTab: action.payload,
      };
    case actionTypes.SET_QUERY_PME:
      return {
        ...state,
        query: action.payload,
      };
    case actionTypes.SET_ACTIF_PME:
      return {
        ...state,
        actif: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_FILTERS_PME:
      return {
        ...state,
        selectedOptionFilters: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_ID_PME:
      return {
        ...state,
        selectedOptionId: action.payload,
      };
    case actionTypes.SET_COLUMN_PME:
      return {
        ...state,
        column: action.payload,
      };
    default:
      return state;
  }
};

export default FiltrePmes;
